import { createContext, useContext, useState } from "react";
import { AccountContextType, PlanType } from "./types";

import { AuthContext } from "./AuthProvider";
import { changePlan, getPlans } from "../api/account";

const defaultAccountContext: AccountContextType = {
  plans: null,
  getPlans: async () => {},
  changePlan: async () => {},
  sessionId: "",
};

export const AccountContext = createContext<AccountContextType>(
  defaultAccountContext,
);

export const AccountProvider = ({ children }: { children: JSX.Element }) => {
  const { onLogout } = useContext(AuthContext);
  const [plans, setPlans] = useState<PlanType[] | null>(null);
  const [sessionId, setSessionId] = useState("");

  const handleGetPlans = async () => {
    const token = localStorage.getItem("token") || null;
    if (!token) {
      onLogout();
      return;
    }

    const response = await getPlans(token);
    if (response) {
      console.log(response);
      setPlans(response);
    }
  };

  const handleChangePlan = async (id: string) => {
    const token = localStorage.getItem("token") || null;
    if (!token) {
      onLogout();
      return;
    }

    const response = await changePlan(token, id);
    if (response) {
      setSessionId(response.sessionId);
      console.log(response);
    }
  };

  const value = {
    plans,
    sessionId,
    getPlans: handleGetPlans,
    changePlan: handleChangePlan,
  };

  return (
    <AccountContext.Provider value={value}>{children}</AccountContext.Provider>
  );
};

export const useAccount = () => {
  return useContext(AccountContext);
};
